import { Typography } from 'antd'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { Keyof } from 'components/CIMSTable/types'
import moment from 'moment'
import { dateFormatter } from '../../../../../../utils/dateFormatter'

/**
 * A wrapper for Expiration Date column
 *
 * @param help Message for help tooltip
 */
export function useExpirationDateColumn<
  T extends { expirationDate: string | null }
>(help?: string): CIMSColumn<T> {
  return {
    title: 'Expiration Date',
    width: help ? 185 : 160,
    help,
    align: 'center',
    render: ({ expirationDate }) => {
      if (!expirationDate) return null
      const formatted = dateFormatter.simple(expirationDate)
      if (moment(expirationDate).endOf('day').isAfter(moment().endOf('day')))
        return formatted
      return <Typography.Text type="warning">{formatted}</Typography.Text>
    },
    sort: { with: 'key', key: 'expirationDate' as Keyof<T> },
    filter: { type: 'date', with: 'key', key: 'expirationDate' as Keyof<T> },
  }
}
